import styled from '@emotion/styled'

import Aos from "aos";
import "aos/dist/aos.css";
import React, { useEffect } from 'react'

import Minaimg from "../../../assets/images/compimg.png"
import Minbg from "../../../assets/images/mainbg.png"

import telegram from "../../../assets/images/telegram.png"
import twitter from "../../../assets/images/twitter.png"
import medium from "../../../assets/images/medium.png"
import { P, SectionHeading } from '../../Styles/style';
import { Container } from '@mui/material';
const Wrapper = styled.div`
min-height: 100vh;
background-image: url(${Minbg});
background-size: cover;
background-position: center;
display: flex;
align-items: center;
justify-content: center;

text-align: center;
`
const MainImg = styled.img`  
width: 100%;
max-width: ${(props) => (props.maxWidth ? props.maxWidth : "850px")};

`
const ConnectButt = styled.a`
background-color: ${(props) => (props.bgcolor ? props.bgcolor : props.theme.btnPrimary)};
margin: ${(props) => (props.m ? props.m : "10px 0")};
padding: ${(props) => (props.p ? props.p : "11px 30px")};
font-family: "Poppins-Medium";
font-size: 15px;
color: ${(props) => props.theme.textPrimary};
text-decoration:none ;
cursor: pointer;
border: 1px solid ${(props) => (props.border ? props.border : props.theme.textPriamry)};
@media screen and (max-width:599px){
  padding: ${(props) => (props.p ? props.p : "11px 10px")};

}
`
const ScialDIv = styled.div`
  display: flex;
  align-items: center;
  place-items: flex-end;
  padding:10px 0;
  place-content: center;
`
const SOcialIm = styled.img`
width:100%;
max-width: 20px;
/* padding-right: 10px; */
margin-right: 10px;
`
const A = styled.a`

`
const ComingSoon = () => {
    useEffect(() => {
        Aos.init({ duration: 2000 });
        window.addEventListener("load", function () {
            Aos.init();
        });
    }, []);
    return (
        <Wrapper>
                <div>
                 <Container maxWidth="xl">   
                <MainImg data-aos="fade-zoom-in"
                    data-aos-easing="ease-in"
                    data-aos-delay="400"
                    data-aos-offset="0"
                    data-aos-duration="500" src={Minaimg} />
                <SectionHeading align="center" p="40px 0" data-aos="zoom-in"
                data-aos-easing="ease-in"
                data-aos-delay="500"
                data-aos-offset="0"
                data-aos-duration="500">Wallet Will Be Live Soon!
                </SectionHeading>
                <ConnectButt href="/" data-aos="zoom-in"
                data-aos-easing="ease-in"
                data-aos-delay="500"
                data-aos-offset="0"
                data-aos-duration="500">Back To Home</ConnectButt>
                <ScialDIv><P align="center" p="20px 10px 0 0" m="0" fs="20px" data-aos="zoom-in"
                data-aos-easing="ease-in"
                data-aos-delay="500"
                data-aos-offset="0"
                data-aos-duration="500">Follow us:</P>
                <A href="#" target="blank" data-aos="zoom-in"
                  data-aos-easing="ease-in"
                  data-aos-delay="700"
                  data-aos-offset="0"
                  data-aos-duration="500"><SOcialIm src={twitter} /></A>
                <A href="#" target="blank" data-aos="zoom-in"
                  data-aos-easing="ease-in"
                  data-aos-delay="800"
                  data-aos-offset="0"
                  data-aos-duration="500"><SOcialIm src={telegram} /></A>
                <A href="#" target="blank" data-aos="zoom-in"
                  data-aos-easing="ease-in"
                  data-aos-delay="900"
                  data-aos-offset="0"
                  data-aos-duration="500"><SOcialIm src={medium} /></A>
              </ScialDIv>
              </Container>
        </div>
            </Wrapper>
    )
}

export default ComingSoon